import { Grid2, Typography, Divider } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";

import Accordion from "../components/Accordion.js";
import Search from "../components/Search.js";
import Spinner from "../components/Spinner.js";
import { isFuzzyMatch, useSnackbar, dayjs } from "../utils/index.js";
import { getUsersData } from "../api/index.js";

const Users = () => {
	const { error } = useSnackbar();
	const [isLoading, setIsLoading] = useState(false);
	const [searchFilter, setSearchFilter] = useState("");
	const [users, setUsers] = useState([]);
	const [filteredUsers, setFilteredUsers] = useState(users);

	const fetchData = useCallback(
		async () => {
			setIsLoading(true);

			try {
				const { success: scs, users: usrs } = await getUsersData();
				if (scs) {
					setUsers(usrs);
				} else {
					error();
				}
			} catch {
				error();
			}

			setIsLoading(false);
		},
		[error],
	);

	useEffect(() => {
		(async () => {
			await fetchData();
		})();
	}, [fetchData]);

	useEffect(() => {
		setFilteredUsers(users.filter((us) => isFuzzyMatch(us.username, searchFilter)
			|| isFuzzyMatch(us.email, searchFilter)
			|| isFuzzyMatch(us.lastActiveAt, searchFilter)
			|| isFuzzyMatch(us.createdAt, searchFilter)));
	}, [searchFilter, users]);

	return (
		<>
			<Spinner open={isLoading} />
			<Grid2
				container
				display="flex"
				direction="column"
				alignItems="center"
				justifyContent="center"
			>
				<Grid2
					container
					width="100%"
					display="flex"
					minHeight="60px"
					borderRadius="10px"
					alignItems="center"
					justifyContent="flex-end"
				>
					<Grid2
						size={{ xs: 6 }}
						display="flex"
						flexDirection="row"
						alignItems="center"
					>
						<Search value={searchFilter} onChange={(event) => setSearchFilter(event.target.value)} />
					</Grid2>
				</Grid2>
				<Grid2 mt={2} width="100%">
					<Accordion
						alwaysExpanded
						title={(
							<Grid2
								container
								display="flex"
								direction="row"
								alignItems="center"
								justifyContent="center"
							>
								<Grid2 size={{ xs: 12 }}>
									<Typography>{"Users"}</Typography>
								</Grid2>
							</Grid2>
						)}
						subtitle={(
							<Grid2 container display="flex" direction="row" alignItems="center" justifyContent="center" spacing={0}>
								<Grid2 size={{ xs: 4 }}>
									<Typography>{"Username"}</Typography>
								</Grid2>
								<Grid2 size={{ xs: 4 }}>
									<Typography>{"E-mail"}</Typography>
								</Grid2>
								<Grid2 size={{ xs: 2 }} textAlign="center">
									<Typography>{"Created At"}</Typography>
								</Grid2>
								<Grid2 size={{ xs: 2 }} textAlign="center">
									<Typography>{"Last Active At"}</Typography>
								</Grid2>
							</Grid2>
						)}
						content={(
							<Grid2 container width="100%" display="flex" direction="column" alignItems="center" justifyContent="center" spacing={0} color="black">
								{filteredUsers.map((us, ind) => (
									<Grid2 key={`comp_${ind}`} flexDirection="column" width="100%">
										{ind !== 0
										&& (
											<Grid2 key={`divider_${ind}`} my={1} width="100%">
												<Divider style={{ width: "100%" }} />
											</Grid2>
										)}
										<Grid2 key={`row_${ind}`} container alignItems="center">
											<Grid2 size={{ xs: 4 }}>
												<Typography>{us.username}</Typography>
											</Grid2>
											<Grid2 size={{ xs: 4 }}>
												<Typography>{us.email}</Typography>
											</Grid2>
											<Grid2 size={{ xs: 2 }} textAlign="center">
												<Typography>{dayjs(us.createdAt).format("DD/MM/YYYY HH:mm")}</Typography>
											</Grid2>
											<Grid2 size={{ xs: 2 }} textAlign="center">
												<Typography>{dayjs(us.lastActiveAt).format("DD/MM/YYYY HH:mm")}</Typography>
											</Grid2>
										</Grid2>
									</Grid2>
								))}
							</Grid2>
						)}
					/>
				</Grid2>
			</Grid2>
		</>
	);
};

export default memo(Users);
